<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="票据查询"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="print">打印</el-button>
        <el-button @click="onPage(1)">查询</el-button>
        <div>
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}"
                           :contentStyle="{width:'42%'}">
            <el-descriptions-item label="票据类型">
              <el-select v-model="where.bill_type" size="mini" placeholder="票据类型" filterable remote clearable
                         reserve-keyword :remote-method="getOrderBillTypeList" style="width: 100%;">
                <el-option v-for="item in order_bill_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="发票代码">
              <el-input size="mini" v-model="where.invoice_code" clearable placeholder="发票代码"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="开票客户">
              <el-input size="mini" v-model="where.customer_name" clearable placeholder="开票客户"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="票据号码">
              <el-input size="mini" v-model="where.bill_number" clearable placeholder="票据号码"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="开票时间">
              <el-date-picker v-model="where.start_invoicing_time" type="date" format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd" size="mini" style="width: 47%;"
                              placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="where.end_invoicing_time" type="date" size="mini" style="width: 47%;"
                              placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="房产信息">
              <el-select v-model="where.house_name" size="mini" placeholder="可搜索房产" filterable remote clearable
                         reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="结算方式">
              <el-select v-model="where.settlement_method" size="mini" placeholder="结算方式" filterable remote clearable
                         reserve-keyword :remote-method="getOrderPaymentList" style="width: 100%;">
                <el-option v-for="item in order_payment_list" :key="item.id" :label="item.name" :value="item.number"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="收费项目">
              <el-select v-model="where.chang_item_id" size="mini" placeholder="收费项目" filterable remote clearable
                         reserve-keyword :remote-method="getHouseChargeItemList" style="width: 100%;">
                <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.chargeItem_name"
                           :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="收费标准">
              <el-select v-model="where.charg_standard_id" size="mini" placeholder="收费标准" filterable remote clearable
                         reserve-keyword :remote-method="getHouseChargeList" style="width: 100%;">
                <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="押金类型">
              <el-select v-model="where.deposit_type_id" size="mini" placeholder="押金类型" filterable remote clearable
                         reserve-keyword :remote-method="getOrderDepositTypeList" style="width: 100%;">
                <el-option v-for="item in order_deposit_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="开票金额">
              <el-input v-model="where.start_money" size="mini" style="width: 47%;" placeholder=""></el-input>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-input v-model="where.end_money" size="mini" style="width: 47%;" placeholder=""></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="">

            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <el-table v-loading="loading" ref="multipleTable" :data="pageData.list" border tooltip-effect="dark" style="width: 100%"
                    height="55vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="ball_type" label="票据类型" width="100"></el-table-column>
            <el-table-column prop="bill_number" label="票据号码" width="120">
              <template slot-scope="scope">
                <el-link type="primary" @click="showDetailed(scope.row)">{{ scope.row.bill_number }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_code" label="发票代码" width="120"></el-table-column>
            <el-table-column prop="customer_name" label="开票客户" width="120"></el-table-column>
            <el-table-column prop="house_name" label="开票房产" width="320"></el-table-column>
            <el-table-column prop="all_money" label="开票金额" width="100"></el-table-column>
            <el-table-column prop="invoicing_time" label="开票日期/操作员" width="120">
              <template slot-scope="scope">
                {{ scope.row.invoicing_time }}/{{ scope.row.invoicing_user_name }}
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="备注" width="120"></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <!-- <el-link type="primary" @click="chargeAgainst(scope.row)">冲销</el-link> -->
                <el-link type="primary" @click="updateRemarks(scope.row)">修改备注</el-link>
                <el-link type="primary" @click="printOrder(scope.row.business_ids)">重打票据</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages">
        <!--        <Page :total="pageData.count" :page-size="pageData.page" @on-change="onPage" show-total />-->
        <el-pagination background layout="prev, pager, next" :total="pageData.count*1" :page-size="pageData.page_size*1"
                       :current-page="pageData.page*1" @current-change="onPage"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name:"NewInvoicingSelect",
  data() {
    return {
      where: {
        bill_type: "",
        bill_number: "",
        customer_name: "",
        invoice_code: "",
        house_name: "",
        settlement_method: "",
        chang_item_id: "",
        charg_standard_id: "",
        deposit_type_id: "",
        start_money: "",
        end_money: "",
        start_invoicing_time: "",
        end_invoicing_time: ""
      },
      pageData: {
        page: 0,
        page_size: 20,
        list: [],
        count: 0
      },
      house_charge_item_list: [],
      house_charge_list: [],
      project_id:0,
      order_bill_type_list:[],
      order_deposit_type_list:[],
      order_payment_list:[],
      loading_dade: 1,
      dialogVisible: false,
      tableData: [],
      order: [],
      money_val: 0,
      money: 0,
      total: 0,
      page: 50,
      date: {
        date_s: '',
        date_e: '',
        bill_type: '全部',
        type: '模糊查询',
        select: '明细',
      },
      select: {
        pay: '',
        house: '',
        name: '',
        date: ''
      },
      xsc_bill_no: '',
      house: [],
      remerks: '',
      loading: false
    }
  },
  inject: ['__ORDER__'],
  mounted() {

  },
  //事件
  methods: {
    //返回数据
    getInvo(data, house) {
      console.log(data, house)
      this.where.start_invoicing_time = data.date;
      this.where.end_invoicing_time = data.date;
      this.project_id=data.project_id
      this.where.house_name = house[0]?house[0].house:house.house;
      this.dialogVisible = true;
      this.getData()
      this.getHouseChargeItemList()
      this.getOrderBillTypeList()
      this.getOrderDepositTypeList()
      this.getOrderPaymentList()
    },
    onPage(page) {
      const that = this;
      that.pageData.page = page;
      that.getData()
    },
    getData() {
      const that = this;
      that.loading=true;
      let where = ERP.reJson(that.where)
      where.page = that.pageData.page;
      where.page_size = that.pageData.page_size;
      ERP.getRequest({
        url: "admin/FinanceBillDetailed/getMaterList",
        data: where,
      }, ret => {
        that.loading=false;
        if (ret.code) {
          that.pageData = ret.data
        }
      })
    },
    handleClose(done) {
      done();
    },
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map(req => {
        money = Number(money) + Number(req.charge_paid);
      })
      this.money_val = money.toFixed(2);
    },
    print() {
      let id = this.order.map(req => {
        return req.id
      }).join(',');
      if (id == '') {
        this.$Message.error('请选择打印项!');
      } else {
        this.$parent.prin(id);
      }
    },
    updateRemarks(item) {
      const that = this;
      that.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        ERP.postRequest({
          url: "admin/FinanceBillDetailed/updateRemarks",
          data: {
            bill_number: item.bill_number,
            remarks: value
          }
        }, ret => {
          if (ret.code) {
            that.$message.success("修改成功")
            that.getData();
          } else {
            that.$message.error(ret.msg || "修改异常")
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    chargeAgainst(item) {

    },
    printOrder(ids) {
      this.$parent.prin(ids);
    },
    showDetailed(item) {
      const that = this;
      console.log(that.__ORDER__)
      if(this.__ORDER__){
        that.__ORDER__.$refs.FinanceBillDetailed.show({
          project_id:that.project_id,
          house_name:that.where.house_name,
          chang_item_id:that.where.chang_item_id,
          ...item
        });
      }else {
        that.$parent.$refs.FinanceBillDetailed.show({
          project_id:that.project_id,
          house_name:that.where.house_name,
          chang_item_id:that.where.chang_item_id,
          ...item
        });
      }

    },
    //远程搜索
    remoteMethod(query) {
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name1?house_name=' + query, {
          'Content-Type': 'application/json'
        }).then(backdata => { // 异步执行成功后
          this.house = backdata.data.data;
        });
      }
    },
    getOrderPaymentList() {
      const that = this;
      let where = {};
      ERP.getRequest({
        url: "admin/OrderPayment/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 400
        }
      }, ret => {
        if (ret.code) {
          that.order_payment_list = ret.data.list;
        }
      })
    },
    getOrderDepositTypeList() {
      const that = this;
      let where = {};
      ERP.getRequest({
        url: "admin/OrderDepositType/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 400
        }
      }, ret => {
        if (ret.code) {
          that.order_deposit_type_list = ret.data.list;
        }
      })
    },
    getOrderBillTypeList() {
      const that = this;
      let where = {};
      ERP.getRequest({
        url: "admin/OrderBillType/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 400
        }
      }, ret => {
        if (ret.code) {
          that.order_bill_type_list = ret.data.list;
        }
      })
    },
    getHouseChargeItemList() {
      const that = this;
      let where = {};
      ERP.getRequest({
        url: "admin/HouseChargeitemName/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 400
        }
      }, ret => {
        if (ret.code) {
          that.house_charge_item_list = ret.data.list;
        }
      })
    },
    getHouseChargeList() {
      const that = this;
      let where = {};
      this.project_id && (where.pindex_id = this.project_id);
      this.where.chang_item_id && (where.chargeItem_name_id = this.where.chang_item_id);
      ERP.getRequest({
        url: "admin/HouseCharge/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      }, ret => {
        if (ret.code) {
          that.house_charge_list = ret.data.list;
        }
      })
    },
  },
  watch:{
    "where.chang_item_id":function (n,o) {
      this.getHouseChargeList()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/NewInvoicingSelect.vue